// utils
import React from "react";
import { useMatch } from "react-router-dom";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// components
import GrantTile, { GrantTileSide } from "../grant-tile/grant-tile";

// files
import eu_banner from "../../../../files/images/pages/grants/eu_mpo_cofinanced_banner_cs.webp";

/**
 * GrantsMars section
 * MARS grant project tile used on GRANTS page
 * @returns HTML code for GrantsMars section
 */
export default function GrantsMars(props: {side: GrantTileSide}) {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    let translation = translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    return (
        <GrantTile
            side={props.side}
            header={translation.header}
            info={[
                translation.info.programme,
                translation.info.call,
                translation.info.registration,
                translation.info.recipient,
            ]}
            cofinancedNote={translation.cofinanced_note}
            bannerSrc={eu_banner}
            bannerAlt={translation.alt.eu_banner}
            btnText={translation.btn_read_more}
            url={getUrlPrefix(language) + "grants/mars"}
        />
    );
}
